import { render, staticRenderFns } from "./ProductDetails.vue?vue&type=template&id=4d59d96e&scoped=true&"
import script from "./ProductDetails.vue?vue&type=script&lang=js&"
export * from "./ProductDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetails.vue?vue&type=style&index=0&id=4d59d96e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d59d96e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d59d96e')) {
      api.createRecord('4d59d96e', component.options)
    } else {
      api.reload('4d59d96e', component.options)
    }
    module.hot.accept("./ProductDetails.vue?vue&type=template&id=4d59d96e&scoped=true&", function () {
      api.rerender('4d59d96e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/partial/product/details/ProductDetails.vue"
export default component.exports